import { ENUM_getInstance25239ht7oag6o as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import {
  cellView255m1dxiud5di as cellView,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  VirtualEnumValue7ord04id8ran as VirtualEnumValue,
  StringValue3s88kmb638dp as StringValue,
  getElementSerializableAnnotations1pxi95cizsm0v as getElementSerializableAnnotations,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/VirtualType.mjs';
import { titleCase1rwupo9lkd0x6 as titleCase } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/casing.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { nullElement39ujy5fzowmto as nullElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { enumValues198w9mpbetxy6 as enumValues } from './serializerManipulation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerEnum(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, VOID, ENUM_getInstance()), EnumRenderer_getInstance());
}
function getInstance($this, serializer) {
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = $this.cache_1;
  var value = this_0.get_wei43m_k$(serializer);
  var tmp;
  if (value == null) {
    var answer = new (EnumRendererInstance())(serializer);
    this_0.put_4fpzoq_k$(serializer, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  var tmp_0 = tmp;
  return tmp_0 instanceof EnumRendererInstance() ? tmp_0 : THROW_CCE();
}
var EnumRendererClass;
function EnumRenderer() {
  if (EnumRendererClass === VOID) {
    class $ {
      constructor() {
        EnumRenderer_instance = this;
        this.name_1 = 'Dropdown';
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.cache_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_28tizu_k$(context, module_0) {
        return 0.9;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_28tizu_k$(context, module_0);
      }
      form_klw3k6_k$(context, value, module_0) {
        var instance = getInstance(this, context.serializer_1);
        return instance.form_gie6yk_k$(context instanceof RenderContext() ? context : THROW_CCE(), value, module_0);
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      view_3m91zp_k$(context, value, module_0) {
        var instance = getInstance(this, context.serializer_1);
        return instance.view_bqdmap_k$(context instanceof RenderContext() ? context : THROW_CCE(), value, module_0);
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_3m91zp_k$(context, value, module_0);
      }
      cellForm_ks8aws_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_ks8aws_k$(context, value, module_0);
      }
      columnWidth_g6s04q_k$(context, module_0) {
        return 15.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_g6s04q_k$(context, module_0);
      }
    }
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'EnumRenderer', VOID, VOID, [Renderer()]);
    EnumRendererClass = $;
  }
  return EnumRendererClass;
}
var EnumRenderer_instance;
function EnumRenderer_getInstance() {
  if (EnumRenderer_instance === VOID)
    new (EnumRenderer())();
  return EnumRenderer_instance;
}
function toDisplayName($this, it) {
  var tmp;
  if (it == null) {
    tmp = 'N/A';
  } else {
    var tmp0_safe_receiver = it instanceof VirtualEnumValue() ? it : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_safe_receiver.enum_1.options_1.get_c1px32_k$(tmp0_safe_receiver.index_1);
      // Inline function 'kotlin.collections.find' call
      var tmp0 = it_0.annotations_1;
      var tmp$ret$5;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (element.fqn_1 === 'com.lightningkite.services.data.DisplayName') {
            tmp$ret$5 = element;
            break $l$block;
          }
        }
        tmp$ret$5 = null;
      }
      var tmp0_safe_receiver_0 = tmp$ret$5;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.values_1;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_wei43m_k$('text');
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
      }
      var tmp3_safe_receiver = tmp_1;
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.value_1;
      tmp_0 = tmp4_elvis_lhs == null ? titleCase(it_0.name_1) : tmp4_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver_0 = it instanceof Enum() ? it : null;
      var tmp_3;
      if (tmp2_safe_receiver_0 == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.find' call
        var tmp0_0 = getElementSerializableAnnotations($this.baseSerializer_1, tmp2_safe_receiver_0.ordinal_1);
        var tmp$ret$12;
        $l$block_0: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            if (element_0.fqn_1 === 'com.lightningkite.services.data.DisplayName') {
              tmp$ret$12 = element_0;
              break $l$block_0;
            }
          }
          tmp$ret$12 = null;
        }
        var tmp0_safe_receiver_1 = tmp$ret$12;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.values_1;
        var tmp2_safe_receiver_1 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.get_wei43m_k$('text');
        var tmp_4;
        if (tmp2_safe_receiver_1 == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_4 = tmp2_safe_receiver_1 instanceof StringValue() ? tmp2_safe_receiver_1 : null;
        }
        var tmp3_safe_receiver_0 = tmp_4;
        var tmp4_elvis_lhs_0 = tmp3_safe_receiver_0 == null ? null : tmp3_safe_receiver_0.value_1;
        tmp_3 = tmp4_elvis_lhs_0 == null ? titleCase(tmp2_safe_receiver_0.name_1) : tmp4_elvis_lhs_0;
      }
      tmp_2 = tmp_3;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_2;
    tmp = tmp3_elvis_lhs == null ? titleCase(toString(it)) : tmp3_elvis_lhs;
  }
  return tmp;
}
function EnumRendererInstance$toDisplayName$ref(p0) {
  return constructCallableReference((p0_0) => {
    var tmp0 = p0;
    return toDisplayName(tmp0, p0_0);
  }, 1, 0, 166, 'toDisplayName', [p0]);
}
var EnumRendererInstanceClass;
function EnumRendererInstance() {
  if (EnumRendererInstanceClass === VOID) {
    class $ {
      constructor(serializer) {
        this.name_1 = 'Dropdown';
        var tmp = this;
        var tmp0_elvis_lhs = nullElement(serializer);
        // Inline function 'kotlin.let' call
        var it = enumValues(tmp0_elvis_lhs == null ? serializer : tmp0_elvis_lhs);
        var tmp_0 = serializer.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$() ? plus(listOf(null), it) : it;
        tmp.options_1 = _Constant___init__impl__v45mub(isInterface(tmp_0, KtList()) ? tmp_0 : THROW_CCE());
        var tmp_1 = this;
        var tmp0_elvis_lhs_0 = nullElement(serializer);
        tmp_1.baseSerializer_1 = tmp0_elvis_lhs_0 == null ? serializer : tmp0_elvis_lhs_0;
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_yxj3hb_k$(context, module_0) {
        return 0.9;
      }
      form_gie6yk_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Select())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.bind_64a41i_k$(value, new (Constant())(this.options_1), EnumRendererInstance$toDisplayName$ref(this));
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toDisplayName(this, $this$invoke.invoke_r7m7el_k$(value)));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.form_gie6yk_k$(context, value, module_0);
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return 15.0;
      }
    }
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForClass($, 'EnumRendererInstance', VOID, VOID, [Renderer()]);
    EnumRendererInstanceClass = $;
  }
  return EnumRendererInstanceClass;
}
//region block: exports
export {
  registerEnum as registerEnumorzz7czqky6e,
};
//endregion

//# sourceMappingURL=EnumRenderer.mjs.map
